import * as React from 'react';
/**
 *
 * Original name: Dropbox Scan
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14398%3A89
 *
 */
export const DropboxScanLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M13.115 10.067 16 5.5H5.5V16l4.54-2.872v-3.06h3.075ZM8.5 18.5h10v-10l-4.35 2.784v2.895h-2.915L8.5 18.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
